module.exports = __webpack_public_path__ + "img/2.671b362a.jpg";